import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { formatPrice, getSymbolCurrency } from "@/js/currency/currencies.js";
import { getErrorData, handleErrorData } from "@/js/forms.js";
import { getFullNameUser } from "@/js/user/user.js";
import { paymentStates } from "@/js/lists.ts";
export default {
  name: "PaymentSearchDialog",
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      shown: false,
      options: {
        zIndex: 2000
      },
      gettingPaymentList: {
        isPending: false,
        cancellationToken: null,
        formSearch: {
          label: null
        },
        searchLabelLastUsed: null,
        results: []
      },
      paymentStates: paymentStates
    };
  },
  computed: {
    isLoading: function isLoading() {
      return this.gettingPaymentList.isPending;
    },
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.isLoading;
    }
  },
  methods: {
    open: function open() {
      this.shown = true;
    },
    close: function close() {
      if (!this.isAnyActionInProgress) {
        this.shown = false;
        this.$emit("closed");
      }
    },
    search: function search() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2$gettingPayment;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.gettingPaymentList.isPending = true;
              (_this2$gettingPayment = _this2.gettingPaymentList.cancellationToken) === null || _this2$gettingPayment === void 0 || _this2$gettingPayment.cancel();
              if (!(_this2.gettingPaymentList.formSearch.label === null || _this2.gettingPaymentList.formSearch.label === "")) {
                _context.next = 6;
                break;
              }
              _this2.gettingPaymentList.results = [];
              _this2.gettingPaymentList.isPending = false;
              return _context.abrupt("return");
            case 6:
              _this2.gettingPaymentList.searchLabelLastUsed = _this2.gettingPaymentList.formSearch.label;
              _this2.gettingPaymentList.cancellationToken = axios.CancelToken.source();
              _this = _this2;
              _context.next = 11;
              return request("/v1/payments/search", "post", _this2.gettingPaymentList.formSearch, true, "api", null, _this2.gettingPaymentList.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.gettingPaymentList.isPending = false;
                  var errorData = getErrorData(e, {}, "An error occured. Please contact an administrator.");
                  handleErrorData(_this, errorData);
                  throw e;
                }
              });
            case 11:
              response = _context.sent;
              if (response) {
                _this2.gettingPaymentList.results = response.data.value;
                _this2.gettingPaymentList.isPending = false;
              }
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    orderDetails: function orderDetails(payment) {
      var _payment$order, _payment$order2;
      var detailsRoute = !!((_payment$order = payment.order) !== null && _payment$order !== void 0 && _payment$order.id_order) ? "adminOrderSummary" : "adminInboundDeliveryDetails";
      var id = !!((_payment$order2 = payment.order) !== null && _payment$order2 !== void 0 && _payment$order2.id_order) ? payment.order.id_order : payment.inboundDelivery.id;
      return {
        name: detailsRoute,
        params: {
          id: id
        }
      };
    },
    formatPrice: formatPrice,
    getSymbolCurrency: getSymbolCurrency,
    getFullNameUser: getFullNameUser
  }
};